// extracted by mini-css-extract-plugin
module.exports = {"flip":"list_flip__1-J59"};